module.exports = __webpack_public_path__ + "img/case_mkdh.aca01c12.png";